/** Output profile of the review: every clip is re-encoded to it (16:9, clips fitted inside). */
export const OUTPUT_WIDTH = 1920;
export const OUTPUT_HEIGHT = 1080;
export const OUTPUT_FRAME_RATE = 30;

/** YouTube's recommended upload bitrate for 1080p SDR at 24–30 fps. */
export const OUTPUT_VIDEO_BITRATE = 8_000_000;
export const OUTPUT_AUDIO_BITRATE = 192_000;

/** One audio format for every piece — the AAC encoder refuses a change mid-stream. */
export const OUTPUT_SAMPLE_RATE = 48_000;
export const OUTPUT_CHANNELS = 2;

/** The intro picture grows by this share over the intro — a slow push-in. */
export const INTRO_ZOOM = 0.04;

/** Background of the intro until a template frame is passed, and of the fade between pieces. */
export const BACKGROUND_COLOR = '#000000';
